exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  margin-top: 0;\n  margin-bottom: 24px;\n}\n\nimg {\n  margin-top: 24px;\n  cursor: pointer;\n  max-width: 50%;\n}\n\n.tooltip-content {\n  bottom: 30px !important;\n  left: 30px !important;\n}\n\n.preorder, .waterproof, .book_release {\n  padding-left: 0px;\n}\n\n.preorder > DIV {\n  display: inline-block;\n}\n\n.preorder > DIV:last-child {\n  padding-left: 68px;\n}\n\n.preorder .toggle-switch label {\n  color: #000000;\n}\n\n.preorder .tooltip {\n  margin: 0px;\n}\n\n@media screen and (max-width: 460px) {\n  .preorder > DIV:last-child {\n    padding-left: 0px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/details/details.component.css
// module id = 376
// module chunks = 1